import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { generateProductCode } from '../services/customersService';
import {
  validateCateringCustomerGroup,
  validateFBZCustomerGroup,
} from '../validations/customerGroupValidation';
import { showWarningToast } from '../../../utils/toastHelper';

export default function EditCustomerGroupModal({
  customerGroup,
  isOpen,
  onClose,
  handleEditCustomerGroupSubmit,
  customerCategories,
  type,
}) {
  const { t } = useTranslation('Customer');
  const [formData, setFormData] = useState({
    customer_category: null,
    group: '',
    name: '',
  });
  const [originalData, setOriginalData] = useState(null);
  const resetForm = (e) => {
    setFormData({
      customer_category: null,
      group: '',
      name: '',
    });
    setOriginalData(null);
  };

  useEffect(() => {
    if (customerGroup) {
      const initialData = {
        customer_category: customerGroup.customer_category || null,
        group: customerGroup.group,
        name: customerGroup.name,
      };
      setFormData(initialData);
      setOriginalData(initialData);
    }
  }, [customerGroup]);

  useEffect(() => {
    const modalElement = document.getElementById('edit-customer-group');
    const modalInstance = new window.bootstrap.Modal(modalElement, {
      backdrop: 'static',
      keyboard: false,
    });

    if (isOpen) {
      modalInstance.show();
    } else {
      modalInstance.hide();
    }
    return () => {
      modalInstance.hide();
    };
  }, [isOpen]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  const handleCategoryChange = (e) => {
    const selectedCustomerCategory = customerCategories.find(
      (customer_category) => customer_category.id === e.target.value
    );

    setFormData((prevData) => ({
      ...prevData,
      customer_category: selectedCustomerCategory || null,
    }));
  };

  const handleSubmit = async () => {
    let validationResult;
    if (formData?.customer_category?.name?.toUpperCase() !== 'CATERING') {
      validationResult = await validateFBZCustomerGroup(formData);
    } else {
      validationResult = await validateCateringCustomerGroup(formData);
    }
    if (!validationResult) {
      return;
    }

    if (JSON.stringify(formData) === JSON.stringify(originalData)) {
      showWarningToast(t('NO_CHANGES_WERE_MADE'));
      return;
    }
    if (handleEditCustomerGroupSubmit) {
      const response = await handleEditCustomerGroupSubmit(
        formData,
        customerGroup.id
      );
      if (response?.success) {
        resetForm();
      }
    }
  };

  return (
    <div
      className="modal fade order-ui-setting"
      id="edit-customer-group"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabIndex="-1"
      aria-labelledby="staticBackdropLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h1 className="modal-title fs-5" id="staticBackdropLabel">
              {type === 'FBZ'
                ? t('EDITFBZCUSTOMERGROUP')
                : t('EDITCATERINGCUSTOMERGROUP')}
            </h1>
            <button
              type="button"
              className="btn-close"
              onClick={() => {
                resetForm();
                onClose('edit');
              }}
            ></button>
          </div>
          <div className="modal-body">
            <section className="first">
              <div className="row">
                <div
                  className={`${
                    formData?.customer_category?.name?.toUpperCase() !==
                    'CATERING'
                      ? 'col-sm-4'
                      : 'col-sm-6'
                  }`}
                >
                  <div className="custom-floating-group">
                    <select
                      key={isOpen}
                      className="did-floating-select"
                      name="customer_category"
                      value={formData?.customer_category?.id}
                      onChange={handleCategoryChange}
                      disabled={type === 'FBZ'}
                    >
                      <option value="">{t('SELECTCUSTOMERCATEGORY')}</option>
                      {customerCategories.map((category) => (
                        <option key={category.id} value={category.id}>
                          {category.name}
                        </option>
                      ))}
                    </select>
                    <label className="did-floating-label">
                      {t('CUSTOMERCATEGORY')}
                    </label>
                  </div>
                </div>

                <div
                  className={`${
                    formData?.customer_category?.name?.toUpperCase() !==
                    'CATERING'
                      ? 'col-sm-4'
                      : 'col-sm-6'
                  }`}
                >
                  <div className="did-floating-label-content">
                    <input
                      className="did-floating-input"
                      type="text"
                      name="group"
                      value={formData.group}
                      onChange={handleChange}
                      placeholder=" "
                    />

                    <label className="did-floating-label">
                      {t('CUSTOMERGROUPNAME')}{' '}
                      <span className="required">*</span>
                    </label>
                  </div>
                </div>
                {formData?.customer_category?.name?.toUpperCase() !==
                  'CATERING' && (
                  <div className="col-sm-4">
                    <div className="did-floating-label-content">
                      <input
                        className="did-floating-input"
                        type="text"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        placeholder=" "
                      />

                      <label className="did-floating-label">
                        {t('CUSTOMERGROUPFULLNAME')}
                        <span className="required">*</span>
                      </label>
                    </div>
                  </div>
                )}
              </div>

              <div className="bottom-button">
                <button
                  className="cancel"
                  onClick={() => {
                    resetForm();
                    onClose('edit');
                  }}
                >
                  {t('CANCEL')}
                </button>
                <button className="save" onClick={handleSubmit}>
                  {t('SAVE')}
                </button>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
}
